import { createContext, useContext } from 'react';
export const initialBalancesState = {
    balances: {},
    assets: {}
};
export const SubstraHooksContext = createContext({
    apiProviders: {},
    defaultApiProviderId: '',
    balancesState: initialBalancesState,
    balancesDispatch: () => null,
});
export const useSubstraHooksState = () => {
    return useContext(SubstraHooksContext);
};
export const useBalancesState = () => {
    return useContext(SubstraHooksContext).balancesState;
};
//# sourceMappingURL=context.js.map